import { StateCreator } from "zustand";

import type { SearchCandidateResult } from "@/components/companies/jobs/search-v2/searchV2CandidateResult";
import type { SearchStore } from "@/stores/search";

export interface ReviewSliceState {
  // Search results for interested talents, keyed by talentId so a talent can
  // only ever be held once. The review queue itself is the server's interest
  // rows; this only lets the review sheet keep the result's matched-keyword
  // highlights and candidacy data instead of refetching them. Scoped to one
  // job — results from another job's search mean nothing here.
  reviewResultsJobId: string | null;
  reviewResultsByTalentId: Map<number, SearchCandidateResult>;
}

export interface ReviewSliceActions {
  rememberReviewResults: (
    jobId: string,
    candidates: SearchCandidateResult[],
  ) => void;
}

export type ReviewSlice = ReviewSliceState & ReviewSliceActions;

export const createReviewSlice: StateCreator<
  SearchStore,
  [],
  [],
  ReviewSlice
> = (set, get) => ({
  reviewResultsJobId: null,
  reviewResultsByTalentId: new Map(),

  rememberReviewResults: (jobId, candidates) => {
    const { reviewResultsJobId, reviewResultsByTalentId } = get();
    const isSameJob = reviewResultsJobId === jobId;
    const current = isSameJob ? reviewResultsByTalentId : new Map();
    const isKnown =
      isSameJob &&
      candidates.every(
        (candidate) => current.get(candidate.talentId) === candidate,
      );
    if (isKnown) return;
    const next = new Map(current);
    candidates.forEach((candidate) => {
      next.set(candidate.talentId, candidate);
    });
    set({ reviewResultsJobId: jobId, reviewResultsByTalentId: next });
  },
});
